export class ResizeResult {
    newWidth: number;
    isLandscape: boolean;
}